// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__k8m93","option":"styles_option__M_LnT","with-tooltip":"styles_with-tooltip__PgEnE","note":"styles_note__UBDrs","box":"styles_box__ttUEL"};